'use client';

import React, { useRef, useEffect } from 'react';
import { useTranslations } from 'next-intl';
import { createPortal } from 'react-dom';
import { LoadStatuses, useLoadScript } from '@/shared/hooks/dom/useLoadScript';
import { cn } from '@/shared/lib/classnames/cn';
import { Button } from '@/shared/ui/button';
import { mapVariants } from '../model/variants';
import { FullScreenMap } from './FullScreenMap';
import type { MapProps } from '../model/types';
export const Map: React.FC<MapProps> = ({
  geo,
  size,
  visibleFullMap,
  showFullMap
}) => {
  const t = useTranslations();
  const containerRef = useRef<HTMLDivElement>(null);
  const mapUrl = process.env.NEXT_PUBLIC_MAP_URL;
  const {
    status,
    start: startLoadScript
  } = useLoadScript(mapUrl, {
    async: true
  });
  const isDesktop = () => {
    if (typeof window === 'undefined') return true;
    return window.innerWidth > 768;
  };
  const getMapUrl = () => {
    return `https://static-maps.yandex.ru/1.x/?ll=${geo.longitude},${geo.latitude}&size=530,90&z=14&l=map&pt=${geo.longitude},${geo.latitude},pm2lbm`;
  };
  const loadMap = () => {
    if (status === LoadStatuses.IDLE) {
      startLoadScript();
    }
  };
  const renderFullScreenMap = () => {
    if (!visibleFullMap || typeof window === 'undefined') {
      return null;
    }
    return createPortal(<FullScreenMap geo={geo} />, document.body);
  };
  useEffect(() => {
    if (visibleFullMap && typeof window !== 'undefined') {
      document.documentElement.classList.add('overflow-hidden');
    } else if (!visibleFullMap) {
      document.documentElement.classList.remove('overflow-hidden');
    }
    return () => {
      if (typeof window !== 'undefined') {
        document.documentElement.classList.remove('overflow-hidden');
      }
    };
  }, [visibleFullMap]);
  useEffect(() => {
    if (isDesktop()) return;
    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        loadMap();
        observer.disconnect();
      }
    }, {
      threshold: 0.1,
      rootMargin: '20px'
    });
    if (containerRef.current) {
      observer.observe(containerRef.current);
    }
    return () => {
      observer.disconnect();
    };
  }, []);
  return <>
      <div ref={containerRef} className={cn(mapVariants({
      size
    }))} style={{
      backgroundImage: `url(${getMapUrl()})`
    }} onMouseEnter={loadMap}>
        {!!showFullMap && <Button className="w-64 bg-additionalBlue/10 font-bold text-additionalBlue" size={'sm'} variant={'glassmorphism'} onClick={showFullMap}>
            {t('doctor.profile.show_in_cart')}
          </Button>}
      </div>

      {renderFullScreenMap()}
    </>;
};